import { useEffect } from 'react';
import { Button, Image, Empty, Typography, Modal } from 'antd';
import { DeleteOutlined, StarOutlined, StarFilled } from '@ant-design/icons';
import UploadImg from '../../../../components/Upload/UploadImg';
import { useSingleService } from './SingleServiceStore';

const { Text } = Typography;

function ServiceImages({ serviceId }) {
    const { images, getImages, addImage, deleteImage } = useSingleService();
    useEffect(() => {
        if (serviceId) getImages(serviceId);
    }, [serviceId, getImages]);

    const handleUpload = (filePath) => {
        addImage(serviceId, filePath);
    };

    const handleDelete = (img) => {
        Modal.confirm({
            title: "Rasmni o'chirishni tasdiqlang",
            okText: "O'chirish",
            okType: 'danger',
            cancelText: 'Bekor qilish',
            onOk: () => deleteImage(img.id, serviceId),
        });
    };

    return (
        <div style={{ padding: '16px 0' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                <Text strong style={{ fontSize: 16 }}>Xizmat rasmlari ({images.length})</Text>
                <UploadImg setImgurl={() => { }} setfileinfo={handleUpload} />
            </div>
            {images.length ? (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12 }}>
                    {images.map(img => (
                        <div
                            key={img.id}
                            style={{
                                position: 'relative', borderRadius: 12, overflow: 'hidden',
                                border: img.is_primary ? '2px solid #667eea' : '2px solid #f0f0f0',
                            }}
                        >
                            <Image
                                src={process.env.REACT_APP_URL + img.file_path}
                                width={140}
                                height={140}
                                style={{ objectFit: 'cover', display: 'block' }}
                            />
                            <div style={{
                                position: 'absolute', top: 0, left: 0, right: 0,
                                display: 'flex', justifyContent: 'space-between',
                                padding: '4px 6px',
                                background: 'linear-gradient(180deg, rgba(0,0,0,0.45) 0%, transparent 100%)',
                            }}>
                                <span style={{ color: img.is_primary ? '#fadb14' : '#fff', fontSize: 15 }}>
                                    {img.is_primary ? <StarFilled /> : <StarOutlined />}
                                </span>
                                <Button
                                    type="text" size="small"
                                    icon={<DeleteOutlined style={{ color: '#ff4d4f' }} />}
                                    onClick={() => handleDelete(img)}
                                    style={{ padding: 0 }}
                                />
                            </div>
                            {img.is_primary === 1 && (
                                <div style={{
                                    position: 'absolute', bottom: 0, left: 0, right: 0,
                                    background: '#667eea', color: '#fff',
                                    textAlign: 'center', fontSize: 10, padding: '2px 0', fontWeight: 600,
                                }}>
                                    Asosiy
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            ) : (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Rasmlar yo'q" />
            )}
        </div>
    );
}

export default ServiceImages;
